"use strict";

exports.__esModule = true;
exports.WidgetPaletteItem = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactDnd = require("react-dnd");
var _Theme = require("../../Theme");
var _core = require("@blueprintjs/core");
var _dec, _class, _WidgetPaletteItem; //import { ElementThumbnail } from "../ElementThumbnail";
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var WidgetPaletteItemWrapper = _styledComponents["default"].button.withConfig({
  displayName: "WidgetPaletteItem__WidgetPaletteItemWrapper",
  componentId: "sc-1gp64hw-0"
})(["cursor:move;padding:0.5rem;color:", ";display:flex;flex-direction:row;justify-content:flex-start;align-items:center;border:none;border-bottom:1px solid rgba(0,0,0,0.2);background-color:", ";width:100%;"], (0, _Theme.val)("WidgetPaletteTextColor"), (0, _Theme.val)("WidgetPaletteBackground"));
var WidgetLabel = _styledComponents["default"].span.withConfig({
  displayName: "WidgetPaletteItem__WidgetLabel",
  componentId: "sc-1gp64hw-1"
})(["display:block;margin-bottom:0rem;margin-left:0.25rem;font-size:12px;text-align:center;"]);
var widgetSource = {
  beginDrag: function beginDrag(props) {
    var widget = props.widget,
      onBeginDrag = props.onBeginDrag;
    if (onBeginDrag) {
      onBeginDrag();
    }
    return {
      widget: widget
    };
  },
  endDrag: function endDrag(props) {
    var onEndDrag = props.onEndDrag;
    if (onEndDrag) {
      onEndDrag();
    }
  }
};

/**
 * Displays a draggable toolbar item for an individual widget.
 */
var WidgetPaletteItem = exports.WidgetPaletteItem = (_dec = (0, _reactDnd.DragSource)("widget", widgetSource, function (connect) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview()
  };
}), _dec(_class = (_WidgetPaletteItem = /*#__PURE__*/function (_Component) {
  function WidgetPaletteItem() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(WidgetPaletteItem, _Component);
  var _proto = WidgetPaletteItem.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      widget = _this$props.widget,
      connectDragSource = _this$props.connectDragSource;
    return /*#__PURE__*/_react["default"].createElement(WidgetPaletteItemWrapper, {
      ref: connectDragSource,
      "data-testid": "WidgetPaletteItem"
    }, /*#__PURE__*/_react["default"].createElement(_core.Icon, {
      icon: widget.icon
    }), /*#__PURE__*/_react["default"].createElement(WidgetLabel, {
      "data-testid": "WidgetPaletteItem.label"
    }, widget.label));
  };
  return WidgetPaletteItem;
}(_react.Component), _WidgetPaletteItem.defaultProps = {
  connectDragSource: undefined,
  connectDragPreview: undefined
}, _WidgetPaletteItem)) || _class);